import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const CheckPermission = () => {
  const { permissions } = useSelector(state => state?.auth);
  const permissionsConvert = useMemo(() => {
    const permMap = {};
    Object.keys(permissions).forEach(module => {
      permissions[module].forEach(({ permission, check }) => {
        permMap[`${module}-${permission}`] = check;
      });
    });
    return permMap;
  }, [permissions]);
  const hasPermission = (module, action) => {
    return permissionsConvert[`${module}-${action}`] || false;
  };
  return { hasPermission };
};

export default CheckPermission;
